import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/esnext.string.match-all.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.is-array.js";
import { getCookie } from './cookies';
export var LogGreen = function LogGreen(msg) {
  return console.log("\x1B[32m".concat(msg, "\x1B[37m"));
};
export var Logred = function Logred(msg) {
  return console.log("\x1B[31m".concat(msg, "\x1B[37m"));
};
export function isUndef(v) {
  return v === undefined || v === null;
}

// trim方法的polyfill
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

// 统跳前缀
var HTTP_REG = /^(http|\/\/)/;
var ZZ_REG = /^zhuanzhuan:/;
var ZZSELLER_REG = /^zhuanzhuanseller:/;
var CHECK_REG = /^zzcheck/;
var HUNTER_REG = /^(zzhunter|zzhunterwarrior|zzthunder)/;
var ZLJ_REG = /^zljgo/;
var YIGE_REG = /^zzyige/;

// 判断一个URL是属于哪种类型地址
export var isHTTPUrl = function isHTTPUrl(path) {
  return HTTP_REG.test(path);
};
export var isZZUrl = function isZZUrl(path) {
  return ZZ_REG.test(path);
};
export var isZZSellerUrl = function isZZSellerUrl(path) {
  return ZZSELLER_REG.test(path);
};
export var isCheckUrl = function isCheckUrl(path) {
  return CHECK_REG.test(path);
};
export var isHunterUrl = function isHunterUrl(path) {
  return HUNTER_REG.test(path);
};
export var isZLJUrl = function isZLJUrl(path) {
  return ZLJ_REG.test(path);
};
export var isYigeUrl = function isYigeUrl(path) {
  return YIGE_REG.test(path);
};

// 兼容zzstore
export var isZZ = /58ZhuanZhuan|zzstore|offlinestorecomplex/gi.test(navigator.userAgent);
//
export var isZLJ = /zhaoliangji-v2/i.test(navigator.userAgent);
//
export var isUpDoor = /zzupdoor/i.test(navigator.userAgent);

// 判断是否是安卓
export var isAndroid = function isAndroid() {
  var u = navigator.userAgent;
  var android = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
  return android;
};
var customUrlHook = function customUrlHook(url) {
  return url;
};
export var setCustomUrlHook = function setCustomUrlHook(f) {
  return customUrlHook = f;
};
export var urlFormatter = function urlFormatter(url, isZZAndroid) {
  if (typeof url === 'undefined') return '';
  return _urlHook(_urlFormatter(customUrlHook(url.trim())), isZZAndroid);
};
export var _urlFormatter = function _urlFormatter(url) {
  var protocol = location.protocol;
  if (isZLJ || isZZ) {
    protocol = 'https:';
  }
  return /^\/\//.test(url) ? protocol + url.substring(url.indexOf('/')) : url;
};
export var getShareMessage = function getShareMessage(options) {
  var title = options.title,
    desc = options.desc,
    content = options.content,
    picPath = options.picPath,
    shareUrl = options.shareUrl,
    imageUrl = options.imageUrl,
    url = options.url,
    link = options.link,
    logParam = options.logParam,
    posterPicPath = options.posterPicPath,
    panelType = options.panelType,
    shareType = options.shareType,
    buttonType = options.buttonType,
    needLogin = options.needLogin,
    twoDimensionCodeX = options.twoDimensionCodeX,
    twoDimensionCodeY = options.twoDimensionCodeY,
    twoDimensionCodeW = options.twoDimensionCodeW,
    twoDimensionCodeColor = options.twoDimensionCodeColor,
    shareParam = options.shareParam;
  var defaultPicUrl = '//img1.zhuanstatic.com/common/img/icon-share.jpg';
  var defaultPosterPicPath = '//img1.zhuanstatic.com/common/trade/img/zz_logo.png';
  var _url = urlFormatter(shareUrl || url || link);
  var _pic = urlFormatter(picPath || imageUrl || defaultPicUrl);
  return Object.assign(options, {
    title: title || '分享',
    desc: desc || content,
    content: content || desc,
    shareUrl: _url,
    url: _url,
    share_url: _url,
    link: _url,
    picPath: _pic,
    image_url: _pic,
    imgUrl: _pic,
    imageUrl: _pic,
    icon: _pic,
    logParam: logParam || 'zhuanzhuan',
    posterPicPath: posterPicPath || defaultPosterPicPath,
    panelType: panelType || 'allChannel',
    shareType: shareType || 'common',
    buttonType: buttonType || 'icon',
    needLogin: needLogin || '0',
    twoDimensionCodeX: twoDimensionCodeX || 200,
    twoDimensionCodeY: twoDimensionCodeY || 200,
    twoDimensionCodeW: twoDimensionCodeW || 200,
    twoDimensionCodeColor: twoDimensionCodeColor || '#00ff00',
    shareParam: shareParam || JSON.stringify({
      shareTitle: title || '分享',
      shareContent: content || desc,
      sharePic: _pic
    })
  });
};
export var getDetailUrl = function getDetailUrl(obj) {
  var $customUrl = obj.$customUrl;
  return urlFormatter($customUrl);
};
export var formartChooseAddressRes = function formartChooseAddressRes() {
  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var code = res.code;
  var addressJson = res.addressJson || res.address_json;
  var phone = res.phone || res.address_mobile_phone || res.addressMobilePhone;
  var addressId = res.addressId || res.address_id || res.address_book_id || res.addressBookId;
  var address = res.address;
  var name = res.name || res.address_name || res.addressName;
  var address_state = res.address_state || res.addressState;
  var address_city = res.address_city || res.addressCity;
  var address_county = res.address_county || res.addressCounty;
  var address_street = res.address_street || res.addressStreet;
  var street_number = res.street_number || res.streetNumber;
  code = '0';
  var detail = address;
  if (!address) {
    detail = "".concat(address_state, " ").concat(address_city, " ").concat(address_county, " ").concat(address_street).concat(street_number);
  }
  addressJson = {
    name: name,
    mobile: phone,
    id: addressId,
    addressId: addressId,
    detail: detail
  };
  return _objectSpread(_objectSpread({}, res || {}), {}, {
    code: code,
    addressJson: addressJson
  });
};
export var getUrlParams = function getUrlParams(url) {
  var withoutDecode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  url = url || window.location.href;
  if (url.indexOf('?') < 0) return {};
  var params = {};
  var kvMatches = url.matchAll(/([^?=&]*)=([^&#]*)/g);
  var _iterator = _createForOfIteratorHelper(kvMatches),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var match = _step.value;
      if (match[1]) {
        if (withoutDecode) {
          params[match[1]] = match[2];
        } else {
          params[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return params;
};
export var getHash = function getHash(url) {
  return ~url.indexOf('#') ? url.replace(/.*#/, '') : '';
};
export var addQuery = function addQuery(url, queryObj) {
  var hash = getHash(url);
  var params = {};
  Object.assign(params, queryObj, getUrlParams(url));
  var newParamStr = Object.keys(params).map(function (key) {
    return "".concat(key, "=").concat(encodeURIComponent(params[key]));
  }).join('&');
  return url.replace(/\?.+$/, '').replace(/\#.+$/, '') + (newParamStr && "?".concat(newParamStr)) + (hash && "#".concat(hash));
};
var _urlHook = function _urlHook(url, isZZAndroid) {
  var params = {};
  if (isZZAndroid) {
    // 安卓 webview 不支持location.replace解决方法
    params = {
      isReplaced: 1
    };
  }
  if (!isHTTPUrl(url)) {
    return addQuery(url, params);
  }
  var importantParamArr = ['source', 'channel', 'use_old_href', 'webview', 'gjtitle', 'suMetric', 'metric', 'init_from', 'hasauth',
  // 58端授权参数
  '__t', 'search_metric' // 搜索链路卖场埋点
  ];

  var oldParams = getUrlParams(window.location.href);
  importantParamArr.map(function (key) {
    return oldParams[key] && (params[key] = oldParams[key]);
  });
  return addQuery(url, params);
};
export var addMetricToObj = function addMetricToObj(obj) {
  var metric = obj.metric;
  var newObj = _objectSpread({}, obj);
  if (!metric) {
    var params = getUrlParams(window.location.href);
    if (params.metric) {
      newObj = Object.assign(newObj, {
        metric: params.metric
      });
    }
  }
  return newObj;
};
export var ajaxUrl = function ajaxUrl(url, params) {
  var newUrl = "".concat(url, "?");
  var paramsKeys = Object.keys(params);
  if (paramsKeys.length > 0) {
    paramsKeys.forEach(function (item, index) {
      newUrl = "".concat(newUrl).concat(item, "=").concat(params[item], "&");
    });
  }
  return newUrl;
};
// 判断否是小程序环境
export var isMiniprogram = function isMiniprogram() {
  return (
    // 微信小程序
    navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i) || window.__wxjs_environment === 'miniprogram'
  );
};

// 获取PPU，转成对象
export var getPPU = function getPPU() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PPU';
  var reg = /([^&=]+)=?([^&]*)/g;
  var ppuCookie = getCookie(name) || '';
  // cookie ppu有可能是编码过的,需要解码一下
  if (ppuCookie && ~ppuCookie.indexOf('%3D')) {
    ppuCookie = decodeURIComponent(ppuCookie);
  }
  if (!ppuCookie && name.indexOf('UID=') > -1) {
    ppuCookie = name;
  }
  var ppu = {};
  for (var regExe = reg.exec(ppuCookie); regExe !== null; regExe = reg.exec(ppuCookie)) {
    ppu[regExe[1]] = regExe[2];
  }
  return ppu;
};

// 得到主域名地址
export var getDomain = function getDomain(targetUrl) {
  targetUrl = targetUrl || location.href;
  var isM2Domain = document.domain.indexOf('m2.zhuanzhuan.com') !== -1;
  return /58\.com/.test(targetUrl) ? 'https://m.zhuanzhuan.58.com' : isM2Domain ? 'https://m2.zhuanzhuan.com' : 'https://m.zhuanzhuan.com';
};

// 得到任意地址的主域名
export var getDomainFromURL = function getDomainFromURL(url) {
  return url.match(/^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:\.)?([^:\/\n\?\=]+)/im)[1];
};
export var isIphoneX = function isIphoneX() {
  var ua = navigator.userAgent;
  var isIOS = ua.toLocaleUpperCase().indexOf('IPHONE') >= 0;
  if (isIOS && window.screen.height >= 812) {
    return true;
  }
  return false;
};

// M页域名替换
// 检测到当前域名为m2的时候，保持下一步跳转的域名保持一致
export var domainReplacement = function domainReplacement() {
  var originUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var domainReg = /^.*?(m2\.zhuanzhuan\.com)/;
  var domainOriginReg = /^.*?(m\.zhuanzhuan\.com)/;
  var currentDomain = document.domain;
  if (domainReg.test(currentDomain) && domainOriginReg.test(originUrl)) {
    return originUrl.replace('m.zhuanzhuan.com', currentDomain);
  }
  return originUrl;
};
export var noConflict = function noConflict() {
  if (window.$ && !window.$.fn) {
    window._$ = window.$;
    window.$ = void 0;
  }
};
export var guid = function guid() {
  var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = 32; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
};
export var creatIframe = function creatIframe(src, id) {
  var iframe = document.createElement('iframe');
  // 设置iframe的样式
  iframe.style.width = '100%';
  iframe.style.height = '100vh';
  iframe.style.boxSizing = 'border-box';
  iframe.style.position = 'fixed';
  iframe.style.top = '0';
  iframe.style.left = '0';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.border = 'none';
  iframe.style.zIndex = '10000';
  iframe.id = id;
  iframe.frameborder = 0;
  iframe.src = src;
  document.body.appendChild(iframe);
};
export function getVisibilityChangeSupported() {
  if (typeof document.hidden !== 'undefined') {
    return 'visibilitychange';
  }
  if (typeof document.msHidden !== 'undefined') {
    return 'msvisibilitychange';
  }
  if (typeof document.webkitHidden !== 'undefined') {
    return 'webkitvisibilitychange';
  }
  return undefined;
}

/**
 * 获取 转转/找靓机 app 版本号 (cookie v)
 * @method getZZVersion
 * @return {String} 转转app 版本号
 */
export var getZZVersion = function getZZVersion() {
  // const str = UA
  var ver = '0.0.0';
  try {
    // UA 中
    // const m = str.match(/zzVersion\/(.*?) /)
    // if (m) ver = m[1]
    // cookie 中
    var v = getCookie('v');
    if (v) ver = v;
  } catch (error) {
    console.error('getZZVersion', error);
  }
  return ver;
};
export var logInfo = function logInfo() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  console.log.apply(window, ['[@zz-common/native-adapter]:'].concat(args));
};
export var logWarn = function logWarn() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  console.warn.apply(window, ['[@zz-common/native-adapter]:'].concat(args));
};
export var logError = function logError() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  console.error.apply(window, ['[@zz-common/native-adapter]:'].concat(args));
};
export var compareVersion = function compareVersion(v1, v2) {
  var seq1 = v1.split('.').map(function (subVersion) {
    return parseInt(subVersion);
  });
  var seq2 = v2.split('.').map(function (subVersion) {
    return parseInt(subVersion);
  });
  var len1 = seq1.length;
  var len2 = seq2.length;
  var commonLen = Math.min(len1, len2);
  for (var i = 0; i < commonLen; ++i) {
    if (seq1[i] != seq2[i]) return seq1[i] < seq2[i] ? -1 : 1;
  }
  return len1 == len2 ? 0 : len1 < len2 ? -1 : 1;
};
export var checkSdkSupport = function checkSdkSupport(version) {
  var zzVersion = navigator.userAgent.match(/zzVersion\/(\S*) zzT/);
  return !!(zzVersion && Array.isArray(zzVersion) && compareVersion(zzVersion[1], version) === 1 && (window.zhuanzhuanMApplication || window.zhuanzhuanMApplicationIos) || window.window.hmos_bridge_service);
};
export var isFunction = function isFunction(fn) {
  return typeof fn === 'function';
};